var _defs, _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    zoomAndPan: "magnify",
    viewBox: "0 0 1440 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "fa2bfaa955"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cea3af74ec"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#fa2bfaa955)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -144,
    width: 1728,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "849a6a1388"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.601562 0.121094 L 1168.921875 0.121094 L 1168.921875 771 L 0.601562 771 Z M 0.601562 0.121094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "457ed72243"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123.5 2 L 1168.921875 2 L 1168.921875 712 L 123.5 712 Z M 123.5 2 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b7a4689c78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49 380 L 481 380 L 481 771 L 49 771 Z M 49 380 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b70e53e82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 474.988281 375.441406 L 484.886719 836.882812 L 51.65625 846.171875 L 41.761719 384.734375 Z M 474.988281 375.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e597d8ac14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 125.667969 639.378906 C 196.496094 468.351562 240.109375 538.675781 253.871094 576.167969 C 267.5625 610.425781 278.710938 677.125 263.785156 686.082031 C 251.019531 694.996094 178.894531 654.433594 177.421875 636.113281 C 177.050781 618.84375 231.554688 592.84375 262.574219 579.222656 C 293.617188 566.679688 339.859375 558.128906 365.757812 557.574219 C 380.867188 557.25 388.421875 557.089844 401.488281 562.207031 C 418.890625 568.3125 445.140625 583.945312 458.484375 602.011719 C 471.828125 620.082031 478.949219 650.160156 480.445312 669.558594 C 480.722656 682.511719 479.851562 692.246094 473.632812 704.257812 C 466.449219 721.683594 445.421875 748.046875 430.566406 760.242188 C 419.9375 768.027344 411.371094 771.449219 397.390625 773.910156 C 379.113281 777.542969 345.589844 775.019531 327.105469 768.941406 C 315.140625 764.878906 306.367188 758.585938 297.550781 750.140625 C 288.753906 742.769531 279.960938 735.402344 274.285156 722.566406 C 266.359375 705.460938 258.183594 676.488281 260.933594 653.753906 C 263.707031 632.101562 279.316406 604.773438 290.886719 590.492188 C 299.3125 580.59375 306.75 575.035156 319.585938 569.363281 C 336.710938 562.515625 367.871094 555.371094 389.546875 559.222656 C 411.222656 563.078125 436.34375 576.574219 450.71875 592.460938 C 466.199219 609.402344 477.546875 635.074219 480.191406 657.6875 C 481.734375 679.25 474.78125 707.46875 463.304688 726.070312 C 451.824219 744.671875 430.566406 760.242188 409.191406 770.417969 C 386.761719 781.695312 357.53125 778.003906 330.734375 787.214844 C 299.648438 797.601562 269.984375 824.148438 234.511719 831.386719 C 195.847656 840.855469 135.644531 852.941406 104.988281 833.085938 C 74.308594 812.148438 56.707031 746.667969 51.511719 705.75 C 46.386719 668.074219 53.175781 632.296875 64.285156 596.429688 C 75.390625 560.5625 95.132812 524.511719 117.121094 492.730469 C 140.191406 460.921875 167.488281 424.710938 199.492188 406.746094 C 229.363281 389.914062 271.078125 371.742188 299.417969 384.089844 C 332.117188 398.503906 368.128906 466.832031 373.535156 517.460938 C 379.125 576.722656 333.886719 682.421875 304.527344 723 C 287.769531 747.109375 269.675781 759.375 248.230469 766.3125 C 227.84375 772.148438 198.660156 770.613281 177.921875 760.261719 C 158.289062 750.96875 138.425781 730.878906 129.351562 710.558594 C 120.277344 690.242188 125.667969 639.378906 125.667969 639.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e96f3eb06f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 432 0 L 432 391 L 0 391 Z M 0 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9018865f84"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 425.988281 -4.558594 L 435.886719 456.882812 L 2.65625 466.171875 L -7.238281 4.734375 Z M 425.988281 -4.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75dde38dc8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76.667969 259.378906 C 147.496094 88.351562 191.109375 158.675781 204.871094 196.167969 C 218.5625 230.425781 229.710938 297.125 214.785156 306.082031 C 202.019531 314.996094 129.894531 274.433594 128.421875 256.113281 C 128.050781 238.84375 182.554688 212.84375 213.574219 199.222656 C 244.617188 186.679688 290.859375 178.128906 316.757812 177.574219 C 331.867188 177.25 339.421875 177.089844 352.488281 182.207031 C 369.890625 188.3125 396.140625 203.945312 409.484375 222.011719 C 422.828125 240.082031 429.949219 270.160156 431.445312 289.558594 C 431.722656 302.511719 430.851562 312.246094 424.632812 324.257812 C 417.449219 341.683594 396.421875 368.046875 381.566406 380.242188 C 370.9375 388.027344 362.371094 391.449219 348.390625 393.910156 C 330.113281 397.542969 296.589844 395.019531 278.105469 388.941406 C 266.140625 384.878906 257.367188 378.585938 248.550781 370.140625 C 239.753906 362.769531 230.960938 355.402344 225.285156 342.566406 C 217.359375 325.460938 209.183594 296.488281 211.933594 273.753906 C 214.707031 252.101562 230.316406 224.773438 241.886719 210.492188 C 250.3125 200.59375 257.75 195.035156 270.585938 189.363281 C 287.710938 182.515625 318.871094 175.371094 340.546875 179.222656 C 362.222656 183.078125 387.34375 196.574219 401.71875 212.460938 C 417.199219 229.402344 428.546875 255.074219 431.191406 277.6875 C 432.734375 299.25 425.78125 327.46875 414.304688 346.070312 C 402.824219 364.671875 381.566406 380.242188 360.191406 390.417969 C 337.761719 401.695312 308.53125 398.003906 281.734375 407.214844 C 250.648438 417.601562 220.984375 444.148438 185.511719 451.386719 C 146.847656 460.855469 86.644531 472.941406 55.988281 453.085938 C 25.308594 432.148438 7.707031 366.667969 2.511719 325.75 C -2.613281 288.074219 4.175781 252.296875 15.285156 216.429688 C 26.390625 180.5625 46.132812 144.511719 68.121094 112.730469 C 91.191406 80.921875 118.488281 44.710938 150.492188 26.746094 C 180.363281 9.914062 222.078125 -8.257812 250.417969 4.089844 C 283.117188 18.503906 319.128906 86.832031 324.535156 137.460938 C 330.125 196.722656 284.886719 302.421875 255.527344 343 C 238.769531 367.109375 220.675781 379.375 199.230469 386.3125 C 178.84375 392.148438 149.660156 390.613281 128.921875 380.261719 C 109.289062 370.96875 89.425781 350.878906 80.351562 330.558594 C 71.277344 310.242188 76.667969 259.378906 76.667969 259.378906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5057246d93"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 432,
    y: 0,
    height: 391
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6b37e06fce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 56 345 L 477 345 L 477 717 L 56 717 Z M 56 345 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "17f55d2789"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 585.023438 518.230469 L 369.839844 891.898438 L 43.871094 704.183594 L 259.058594 330.515625 Z M 585.023438 518.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f30ac8bbc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 585.023438 518.230469 L 369.839844 891.898438 L 43.871094 704.183594 L 259.058594 330.515625 Z M 585.023438 518.230469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2143b51934"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 1169,
    y: 0,
    height: 771
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a572ffebc3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 1169,
    y: 0,
    height: 771
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -144,
    width: 1728,
    fill: "#ffffff",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -144,
    width: 1728,
    fill: "#000000",
    y: -80.999999,
    height: 971.999992,
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cea3af74ec)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 135, 39)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a572ffebc3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#849a6a1388)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0.000000000000028422, 0.000000000000035527)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2143b51934)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#457ed72243)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cf0a0a",
    d: "M 489.109375 87.519531 L 534.679688 51.691406 C 649.890625 -38.882812 819.277344 -0.269531 883.894531 131.265625 L 1168.882812 711.375 L 1051.5625 711.375 C 961.835938 711.375 879.957031 660.128906 840.648438 579.46875 L 652.714844 193.816406 C 639.039062 165.746094 618.996094 141.15625 593.882812 122.589844 C 568.664062 103.957031 534.070312 87.933594 490.4375 89.171875 C 500.523438 101.890625 509.460938 115.960938 516.960938 131.242188 L 801.949219 711.351562 L 684.632812 711.351562 C 594.90625 711.351562 513.027344 660.105469 473.71875 579.445312 L 285.804688 193.816406 C 272.128906 165.746094 252.082031 141.15625 226.972656 122.589844 C 201.035156 103.4375 165.246094 87.042969 119.894531 89.324219 L 167.75 51.691406 C 269 -27.90625 412.058594 -7.773438 489.109375 87.519531 Z M 248.410156 464.324219 L 119.785156 711.175781 L 441.082031 711.089844 L 317.089844 464.800781 C 302.9375 436.710938 262.933594 436.453125 248.410156 464.324219 Z M 248.410156 464.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b7a4689c78)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b70e53e82)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e597d8ac14)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 49, 380)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5057246d93)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e96f3eb06f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9018865f84)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75dde38dc8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 467.484375 -43.75 L 478.9375 490.230469 L -36.910156 501.292969 L -48.363281 -32.6875 Z M 467.484375 -43.75 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6b37e06fce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#17f55d2789)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f30ac8bbc4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 59.273438 680.191406 L 245.320312 357.121094 C 254.511719 341.164062 277.523438 341.148438 286.734375 357.074219 L 473.511719 679.742188 C 482.738281 695.679688 471.253906 715.625 452.835938 715.644531 L 80.011719 716.050781 C 61.621094 716.058594 50.085938 696.148438 59.273438 680.191406 Z M 59.273438 680.191406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcms);
export default __webpack_public_path__ + "static/media/CCMS.aaa753d581402a5716413d702f1c9287.svg";
export { ForwardRef as ReactComponent };